import { useState } from 'react';
import { api, type DomainCheckResult } from '../api';
import { CheckCard } from '../components/CheckCard';

export function CheckPage() {
  const [domain, setDomain] = useState('');
  const [selector, setSelector] = useState('');
  const [probe, setProbe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<DomainCheckResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function run(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const r = await api.runCheck({
        domain,
        selector: selector || undefined,
        probeCommonDkim: !selector && probe,
      });
      setResult(r);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="card">
        <h2>Check a domain</h2>
        <form onSubmit={run} className="flex-col">
          <div className="flex">
            <input
              type="text"
              placeholder="example.com"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              autoFocus
            />
            <input
              type="text"
              placeholder="DKIM selector (optional)"
              value={selector}
              onChange={(e) => setSelector(e.target.value)}
              style={{ maxWidth: 280 }}
            />
            <button type="submit" disabled={loading || !domain}>
              {loading ? 'Checking…' : 'Run checks'}
            </button>
          </div>
          <label className="muted">
            <input
              type="checkbox"
              checked={probe}
              disabled={!!selector}
              onChange={(e) => setProbe(e.target.checked)}
            />{' '}
            Probe common DKIM selectors when no selector given
          </label>
        </form>
        {error && <p style={{ color: 'var(--fail)' }}>{error}</p>}
      </div>

      {result && (
        <>
          <div className="grid-2">
            <CheckCard title="DMARC" result={result.dmarc} />
            <CheckCard title="SPF" result={result.spf} />
            <CheckCard title="MX" result={result.mx} />
            {result.dkim ? (
              <CheckCard title={`DKIM (${result.dkim.selector})`} result={result.dkim} />
            ) : (
              <CheckCard title="DKIM" result={undefined} />
            )}
            <CheckCard title="BIMI" result={result.bimi} />
            <CheckCard title="MTA-STS" result={result.mtaSts} />
            <CheckCard title="TLS-RPT" result={result.tlsRpt} />
          </div>
          {result.dkimSelectors && result.dkimSelectors.length > 1 && (
            <div className="card">
              <h2>Other DKIM selectors found</h2>
              {result.dkimSelectors.slice(1).map((s) => (
                <CheckCard key={s.selector} title={`DKIM (${s.selector})`} result={s} />
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
}
